<template>
  <div
    v-if="!imageLoading"
    class="animate__animated animate__fadeIn animate__delay-1s px-3 md:px-5"
  >
    <div
      v-if="!isStickerV2"
      class="sticker-cta py-3 px-3 rounded-2xl md:hidden"
      @click="handleButtonClick()"
    >
      <div class="relative z-10 flex items-center">
        <img
          :src="sticker.image"
          alt="Sticker"
          class="inline-block w-14 mr-2"
        >

        <span class="text-left text-xs" v-html="sticker.text" />
      </div>

      <div class="sticker-cta__decorator right-24" />
    </div>

    <div
      v-if="!isStickerV2"
      class="hidden md:block"
    >
      <div class="relative z-10 text-center transform translate-y-6">
        <img
          :src="sticker.image"
          alt="Sticker"
          class="inline-block"
        >
      </div>

      <div class="sticker-cta pb-5 px-3 pt-8 rounded-2.5xl">
        <div class="relative z-10">
          <div class="px-1 pb-4 text-center" v-html="sticker.text" />

          <div class="text-center">
            <aha-button class="max-w-full" variant="light" @click="handleButtonClick()">
              <span>
                <strong
                  class="text-primary-90 truncate"
                >{{ sticker.buttonText }}</strong>
                <aha-svg
                  v-if="openInNewTab"
                  name="open-new-window"
                  class="ml-1.5 text-primary-80"
                />
              </span>
            </aha-button>
          </div>
        </div>

        <div class="sticker-cta__decorator right-8" />
      </div>
    </div>

    <div
      v-if="isStickerV2"
      class="d-flex justify-center text-center pt-3"
    >
      <img
        :src="sticker.image"
        alt="Sticker"
        class="inline-block max-w-full cursor-pointer"
        @click="handleButtonClick()"
      >
    </div>
  </div>
</template>

<script>
// utils
import utils from '@/util'

// constants
import constants from '@/constant'

const { gaCategories } = constants

export default {
  props: {
    sticker: {
      type: Object,
      default: () => {},
    },
    openInNewTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageLoading: true,
    }
  },
  computed: {
    isStickerV2() {
      return this.sticker && !(this.sticker.text && this.sticker.buttonText)
    },
  },
  mounted() {
    const image = new Image()
    image.src = this.sticker.image

    image.onload = () => {
      this.imageLoading = false
    }

    // Disable for less noise
    // utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Sticker > Show', this.sticker.id)
  },
  methods: {
    handleButtonClick() {
      let windowName = '_self'

      if (this.openInNewTab) {
        windowName = 'blank'
      }

      window.open(this.sticker.buttonUrl, windowName)
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Sticker > Click', this.sticker.id)
    },
  },
}
</script>

<style lang="scss">
.sticker-cta {
  @apply bg-primary-90 relative overflow-hidden;
}

.sticker-cta__decorator {
  @apply absolute w-52 h-52 top-14 bg-primary-100 rounded-full;
}
</style>
